// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_fragment(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "AvailableConversationContext",
    "RemovedConversationContext"
  ]);
}

function unwrap_fragment_AvailableConversationContext_context_ForSalePropertyV5_agentV2(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["VisibleForSalePropertyAgent"]);
}

function unwrap_fragment_AvailableConversationContext_context(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "BuyerNeedV5",
    "ForSalePropertyV5",
    "RentalNeedV5",
    "RentalPropertyV5"
  ]);
}

let fragmentConverter = {"__root":{"AvailableConversationContext_context_RentalPropertyV5_currentUsersMatches_edges_node":{"f":""},"AvailableConversationContext_context_RentalNeedV5_currentUsersMatches_edges_node":{"f":""},"AvailableConversationContext_context_ForSalePropertyV5_currentUsersMatches_edges_node":{"f":""},"AvailableConversationContext_context_ForSalePropertyV5_agentV2":{"u":"fragment_AvailableConversationContext_context_ForSalePropertyV5_agentV2"},"AvailableConversationContext_context_BuyerNeedV5_currentUsersMatches_edges_node":{"f":""},"AvailableConversationContext_context":{"u":"fragment_AvailableConversationContext_context"},"":{"u":"fragment"}}};

let fragmentConverterMap = {
  fragment_AvailableConversationContext_context_ForSalePropertyV5_agentV2: unwrap_fragment_AvailableConversationContext_context_ForSalePropertyV5_agentV2,
  fragment_AvailableConversationContext_context: unwrap_fragment_AvailableConversationContext_context,
  fragment: unwrap_fragment
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

let Utils = {};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "Agent",
  "kind": "LinkedField",
  "name": "agent",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = [
  {
    "kind": "Literal",
    "name": "includeOnlyActive",
    "value": true
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConversationPageSelectedConversationMatches_conversation",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v2/*: any*/),
      "type": "RemovedConversationContext",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "context",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": (v3/*: any*/),
                  "concreteType": "ForSalePropertyCurrentUserMatchesConnection",
                  "kind": "LinkedField",
                  "name": "currentUsersMatches",
                  "plural": false,
                  "selections": [
                    (v4/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ForSalePropertyCurrentUserMatchesEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "MatchForBuyerNeedV5",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "ConversationPageSelectedConversationMatchesBuyerMatches_match"
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": "currentUsersMatches(includeOnlyActive:true)"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "agentV2",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": (v2/*: any*/),
                      "type": "VisibleForSalePropertyAgent",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "ForSalePropertyV5",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": (v3/*: any*/),
                  "concreteType": "RentalPropertyCurrentUserMatchesConnection",
                  "kind": "LinkedField",
                  "name": "currentUsersMatches",
                  "plural": false,
                  "selections": [
                    (v4/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RentalPropertyCurrentUserMatchesEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "MatchForRentalNeedV5",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "ConversationPageSelectedConversationMatchesRenterMatches_match"
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": "currentUsersMatches(includeOnlyActive:true)"
                },
                (v1/*: any*/)
              ],
              "type": "RentalPropertyV5",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": (v3/*: any*/),
                  "concreteType": "BuyerNeedCurrentUserMatchesConnection",
                  "kind": "LinkedField",
                  "name": "currentUsersMatches",
                  "plural": false,
                  "selections": [
                    (v4/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "BuyerNeedCurrentUserMatchesEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "MatchForForSalePropertyV5",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "ConversationPageSelectedConversationMatchesSellerMatches_match"
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": "currentUsersMatches(includeOnlyActive:true)"
                },
                (v1/*: any*/)
              ],
              "type": "BuyerNeedV5",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": (v3/*: any*/),
                  "concreteType": "RentalNeedCurrentUserMatchesConnection",
                  "kind": "LinkedField",
                  "name": "currentUsersMatches",
                  "plural": false,
                  "selections": [
                    (v4/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RentalNeedCurrentUserMatchesEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "MatchForRentalPropertyV5",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "ConversationPageSelectedConversationMatchesRentalOwnerMatches_match"
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": "currentUsersMatches(includeOnlyActive:true)"
                },
                (v1/*: any*/)
              ],
              "type": "RentalNeedV5",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "AvailableConversationContext",
      "abstractKey": null
    }
  ],
  "type": "ContextForConversation",
  "abstractKey": "__isContextForConversation"
};
})());

let wrap_fragment = RescriptRelay_Internal.wrapUnion;

let wrap_fragment_AvailableConversationContext_context_ForSalePropertyV5_agentV2 = RescriptRelay_Internal.wrapUnion;

let wrap_fragment_AvailableConversationContext_context = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment = unwrap_fragment;
exports.wrap_fragment = wrap_fragment;
exports.unwrap_fragment_AvailableConversationContext_context_ForSalePropertyV5_agentV2 = unwrap_fragment_AvailableConversationContext_context_ForSalePropertyV5_agentV2;
exports.wrap_fragment_AvailableConversationContext_context_ForSalePropertyV5_agentV2 = wrap_fragment_AvailableConversationContext_context_ForSalePropertyV5_agentV2;
exports.unwrap_fragment_AvailableConversationContext_context = unwrap_fragment_AvailableConversationContext_context;
exports.wrap_fragment_AvailableConversationContext_context = wrap_fragment_AvailableConversationContext_context;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
